/*
 * HONEYWELL INC.,
 * COPYRIGHT (c) 2022
 * ALL RIGHTS RESERVED
 *
 * This software is a copyrighted work and/or information protected as a trade secret.
 * Legal rights of Honeywell Inc. in this software is distinct from ownership of any medium
 * in which the software is embodied. Copyright or trade secret notices included must be
 * reproduced in any copies authorized by Honeywell Inc.
 *
 */

import {
  IConnector,
  IDataConnectorConfigRaw
} from '@forge/data-connector/dist/IDataConnector';
import { IUtilityProps } from '../shared/BreakdownUtility/BreakdownUtilityProps';
import { scaledData } from '../shared/ProgressBar/IProgressBarWidget';
import { UtilityCostType } from '../shared/Utils/Constants';
import { ISiteEnergyUsageData } from './EMaaSMobileSupervisorPortfolioDashboard/IPortfolioProps';
import {
  IDataPoint,
  IStateValue
} from './EnergyOptimization/EnergyOptimizationInterfaces';
import { IRawTableColumn } from '../shared/UtilityBillBreakdown/SummaryTable/SummaryTable';
import { EnergyUsageDataSourceType } from '../shared/Enums';

export interface IRequestContext {
  rootNodeId: string;
  context: {
    startTime?: string;
    endTime?: string;
    interval?: string;
    siteId?: string;
    nodeId?: string;
    searchKeyword?: string;
    providerId?: string;
    subscriptionType?: string;
    smpSubscriptionType?: string;
    timeFormat?: string;
    isCashFlow?: string;
    userID?: any;
    dataSource?: string;
  };
  headers?: {
    [key: string]: string;
  };
  isEditAllowed?: boolean;
}

export interface IBearerToken {
  token: string;
}

export type toastMessageTypes = 'info' | 'success' | 'warn' | 'error';
export interface IMeterKpiFlags {
  loading: boolean;
  error: boolean;
}
export interface IEMaaSContext {
  onViewDetailsClick?: (route: string, utilityIndex?: number) => void;
  onServicesViewClick?: (route: string) => void;
  onEnergyUsageSiteClick?: (siteId: string) => void;
  ActiveIndex?: number;
  onViewDetailsTabChange?: (activeIndex: number) => void;
  onAddServiceResponse?: (data: IUtiltityAccountResponse) => void;
  onAddServiceDoneClick?: () => void;
  onTemplateDownloadClick?: (
    selectedType: string,
    fileName: string,
    uploadType: string
  ) => void;
  onNewTemplateDownloadClick?: (
    selectedType: string,
    fileName: string,
    uploadType: string
  ) => IAny;
  onUpdatedTemplateDownloadClick?: (
    fileName: string,
    uploadType: string
  ) => void;
  OnUploadClick?: (
    fileList: File[],
    selectedType: string,
    uploadType: string
  ) => void;
  getCsvHeaders?: (uploadType: string) => Promise<string[]>;
  createBulkSpatialElements?: (data: any) => Promise<any>;
  updatePropertiesOfElements?: (data: any) => Promise<any>;
  handleAssociation?: (data: any) => Promise<any>;
  onSiteEnergyUsageCardClick?: () => void;
  onCarbonTabClick?: () => void;
  onEUITabClick?: () => void;
  onUtilityBillViewDetailsClick?: () => void;
  onBacktoDashboardClick?: (isFromSmp?: boolean) => void;
  onCarbonViewDetailsClick?: () => void;
  onEnergyUsageViewDetailsClick?: (tabName?: string) => void;
  redirect?: (redirectUrl: string) => void;
  onPortfolioSiteClick?: (siteId: string) => void;
  onEnergyOptimizationViewDetailsClick?: () => void;
  notifyMessage?: (message: string, type?: toastMessageTypes) => void;
  siteName?: string;
  preferredEuiUnit?: string;
  userPreferedUnit?: string;
  selectedDateFormat?: string;
  selectedTimeFormat?: string;
  isEOSubscribed?: boolean;
  apiCallAt?: ECartAt;
  MultilabelBreakdown?: boolean;
  totalFootprint?: string;
  organizationName?: string;
  currencyCode?: string;
  isScopeFilterEnabled?: boolean;
  isBreakdownEquipment?: boolean;
  toggleFeatureScopeOne?: boolean;
  toggleFeatureScopeTwo?: boolean;
  toggleFeatureGAS?: boolean;
  onEnergyStarViewDetailsClick?: () => void;
  showEnergyStarWidget?: boolean;
  toggleFeatureNILM2?: boolean;
  isNILMSubscribed?: boolean;
  isNILMDisaggregationSubscribed?: boolean;
  getPropertyTemplates?: (a: string[]) => Promise<any>;
  uuid?: () => {};
  viewcreatedMeter?: () => void;
  utilityGraphType?: string;
  graphType?: string;
  getSiteDataForAssociationValidation?: () => Promise<any>;
  onClickGotoSiteHomePage?: () => void;
  previousName?: boolean;
  hideHeader?: boolean;
  hasDisaggIntegration?: boolean;
  showsDisaggregation?: boolean;
  toggleRedaptiveIntegration?: boolean;
  toggleUtilityBreakdownVisualization?: boolean;
  handlePDFDownload?: (payload: {
    logicalAccountId: string;
    accountId: string;
  }) => void;
  onViewChange?: (event: boolean) => void;
  siteId?: string;
  toggleFeatureNewUtilityBuilder?: boolean;
  onManageBill?: IAny;
  onManageTariffDetails?: IAny;
  onEditBill?: IAny;
  setIsManageBill?: IAny;
  setIsManageTariffDetails?: IAny;
  setUtilityCellData?: IAny;
  forPortfolio?: boolean;
  getBillDetails?: IAny;
  manageBillPdfDownload?: IAny;
  saveDillDetails?: IAny;
  onClickViewDetailsMeterTrend?: (meterId: string, meterName: string) => void;
  enableViewDetailsMeterTrend?: boolean;
  countryCode?: string;
  utilityBuilderManualToAutomaticToggle?: boolean;
  isEditAllowed?: boolean;
  UtilityTariffDetailsToggle?: boolean;
  onPublishPointHistoryMeterData?: () => Promise<IAny>;
  onDeleteMeterDataFile?: (fileId: string) => Promise<IAny>;
  submitFileForChunkedUpload?: (file: File, uploadType: string) => void;
  progressTrackingList?: IChunkedUploadProgressState[];
  toggleGasManageBill?: boolean;
  toggleManualWaterSewer?: boolean;
  toggleManualWater?: boolean;
  toggleManageTariffDetails?: boolean;
  toggleEditManualAccount?: boolean;
  getMeterKpiFlag?: IMeterKpiFlags;
  refreshMeterKpi?: any;
  submitbaselinetrainingform?: (
    reqbody: IsubmitbaselineformrequestBody
  ) => Promise<IAny>;
  getBaselineTrainedData?: () => Promise<IAny>;
  isFromSmartPower?: boolean;
  getParamsFromPDF?: IAny;
  ocrManageBill?: boolean;
  totalFootPrintNativeUnit?: string;
  pointHistoryUploadToggle?: boolean;
  energyUsageMultipleCalls?: boolean;
  meterKPICEMSToggle?: boolean;
  setActiveIndexForUtility?: (activeIndex: number) => void;
  setBasicAdvancedGrp?: IAny;
  basicAdvancedGrp?: IAny;
  setMonthlyBillingGrp?: IAny;
  monthlyBillingGrp?: IAny;
  overviewSet?: IAny;
  overViewElectricity?: IAny;
  isMonthlyElectricity?: boolean;
  setIsMonthlyElectricity?: IAny;
  utilityBillBaselineActionClick?: (meterId: string) => void;
  enableWaterUsageDashboards?: boolean;
  convertToAutomaticForGas?: boolean;
  toggleAutomaticBillCategories?: boolean;
  getCurrentPageInfinite?: (startInd: number, endInd: number) => void;
  getCurrentPage?: (page: string | number) => void;
  MAX_METERS_COUNT?: number;
  showChangeWhenData?: boolean;
  toggleUtilityLevelIBO?: boolean;
  toggleEnableEoTable?: boolean;
  onEOUtilityTabChange?: (activeTab: string) => Promise<IAny>;
  eoAvailableTabs?: string[];
  enableConsumptionSourceSelect?: boolean;
  cemsEnableCarbonSourceSelect?: boolean;
  dataSourceType?: string | null;
  setDataSourceType?: (dataSourceType: string | null) => void;
  triggerDateChange?: boolean;
  getPortfolioEnergyTableData?: (utilityType: string) => void;
  getNextMetersData?: (
    areaData: string,
    meterIds: string[],
    utilityType: string
  ) => Promise<Array<{ [key: string]: string }>>;
  toggleSeparateApi?: boolean;
  getEnergyUsageTableData?: (utilityType: string) => void;
  toggleMultipleUploadUtility?: boolean;
  getParamsFromPDFForMultipleUpload?: IAny;
  enableInfiniteScrollSubmeterKpi?: boolean;
  enableAutomaticEditAccount?: boolean;
  optimusSubscribed?: boolean;
  submeterKpiSelectedPeriodCons?: boolean;
  getTableData?: (body: any) => void;
  toggleUtilityBillBreakdownPerformance?: boolean;
  getUtilityGraphData?: IAny;
  getUtilityAccountNumbers?: IAny;
  enableZLODataUpload?: boolean;
  disableDateApply?: IAny;
  carbonDataSourceInitial?: string;
  setCarbonDataSourceInitial?: (type: string | null) => void;
  eoStatus?: number;
  toggleEnableEoStatus?: boolean;
  cemsIntervalEnergySourceOption?: boolean;
  enableIDSEnrollment?: boolean;
  saveEOStatusRuntime?: (status: IAny, dayType: IAny) => void;
  eoStatusRuntime?: IAny;
  toggleEnableKwhGas?: boolean;
  toggleOpportunityFromEO?: boolean;
  lastUpdated?: string;
  isStatusCompleted?: boolean;
  saveEoOperationalTime?: (operationalTime: IAny) => void;
  eoOperationalTime?: number;
  eoActiveHours?: IAny;
  reasonForOff?: IAny;
  userSelectedTemperatureUnit?: string;
}
export interface IsubmitbaselineformrequestBody {
  trainingStartDate: string;
  trainingEndDate: string;
  applyBaselineFrom: string;
  exclusionStartDate: string | null;
  exclusionEndDate: string | null;
}
export interface meterDetailsFromParent {
  ElectricityConsumption: number | string;
  ElectricityConsumptionUnit: string;
  FifteenMinuteElectricConsumption: number | string;
  FifteenMinuteElectricConsumptionPrediction: number | string;
  FifteenMinuteElectricConsumptionPredictionUnit: string;
  FifteenMinuteElectricConsumptionUnit: string;
  PowerDemand: number | string;
  PowerDemandUnit: string;
  meterID: string;
  meterName: string;
  countryCode?: string;
  utilityBuilderManualToAutomaticToggle?: boolean;
  isEditAllowed?: boolean;
  PowerDemandDisplay: boolean;
  ActivePowerDisplay: boolean;
  ActivePower: number | string;
  ActivePowerUnit: string;
  EnergyConsToday: number | string;
  EnergyConsMonth: number | string;
  EnergyConsMonthUnit: string;
  EnergyConsTodayUnit: string;
  maxPowerTimeOfActivePower: string;
}
export default interface IEnergyManagementProps {
  connectorConfig: IDataConnectorConfigRaw;
  bearerToken?: string;
  requestContext: IRequestContext;
  emaasContext?: IEMaaSContext;
  carbonApiFor?: ECarbonCartAt;
  siteName?: string;
  preferredEuiUnit?: string;
  userPreferedUnit?: string;
  organizationName?: string;
  widgetType?: UtilityCostType;
  utilityType?: string;
  displayWidgets?: string[];
  SetactiveIndex?: (activeIndex: string) => void;
  toggleFeatureScopeOne?: boolean;
  toggleFeatureScopeTwo?: boolean;
  toggleFeatureGAS?: boolean;
  toggleFeatureAllUpload?: boolean;
  displayLable?: IAny;
  displayBaseline?: boolean;
  parentPutAxios?: IAny;
  toggleFeaturePointHistoryUpload?: IAny;
  pointHistoryUploadToggle?: boolean;
  toggleFeatureNewUtilityBuilder?: boolean;
  integrationType?: string;
  getAllMeterData?: meterDetailsFromParent[];
  meterKPICEMSToggle?: boolean;
  getCurrentPage?: (page: string | number) => void;
  MAX_METERS_COUNT?: number;
  triggerDateChange?: boolean;
  dataSourceType?: EnergyUsageDataSourceType | string | null;
  setDataSourceType?: (
    dataSourceType: EnergyUsageDataSourceType | string | null
  ) => void;
  //toggleUtilityBreakdownVisualization?: boolean;
  optimusSubscribed?: boolean;
  dataSourceInitial?: string;
  storeDataSourceType?: (type: string | null) => void;
  carbonDataSourceInitial?: string;
  storeCarbonDataSourceInitial?: (type: string | null) => void;
  tooltipContent?: IAny;
  isEnergyDeatils?: Function;
}

export interface IDetailComponentPropsSeparateAPI {
  dataConnector: IConnector<IAny>;
  dataSourceType?: EnergyUsageDataSourceType | string | null;
  setDataSourceType?: (
    dataSourceType: EnergyUsageDataSourceType | string | null
  ) => void;
  dataConnectorPerformanceAggregation: IConnector<IAny>;
  avoidanceData?: ICarbonAvoidanceData;
  UtilityBillType?: string;
  headerTitle?: string;
  tabName?: string;
  subscriptionType?: string;
  bearerToken?: string;
  requestContext?: IRequestContext;
  toggleFeatureScopeOne?: boolean;
  nilmTab?: string;
  setHeader?: any;
  getAllMeterData?: meterDetailsFromParent[];
  getCurrentPage?: any;
  MAX_METERS_COUNT?: number;
  utilityType?: string;
  emaasContext?: IEMaaSContext;
  scope?: string;
  ActiveIndex?: number;
  tableData?: any;
  loading?: any;
  error?: any;
  statusCode?: any;
  onRefresh?: () => Promise<IAny>;
}

export interface IPremiumDetailComponentProps {
  avoidanceData?: ICarbonAvoidanceData;
  UtilityBillType?: string;
  headerTitle?: string;
  tabName?: string;
  subscriptionType?: string;
  bearerToken?: string;
  requestContext?: IRequestContext;
  toggleFeatureScopeOne?: boolean;
  nilmTab?: string;
  setHeader?: any;
  getAllMeterData?: meterDetailsFromParent[];
  getCurrentPage?: any;
  MAX_METERS_COUNT?: number;
  utilityType?: string;
  emaasContext?: IEMaaSContext;
  scope?: string;
  ActiveIndex?: number;
  tableData?: any;
  loading?: any;
  error?: any;
  statusCode?: any;
  onRefresh?: () => Promise<IAny>;
}
export interface IDetailComponentPropsSeparateEmissionAPI {
  dataConnector: IConnector<IAny>;
  dataConnectorForGraph: IConnector<IAny>;
  avoidanceData?: ICarbonAvoidanceData;
  UtilityBillType?: string;
  headerTitle?: string;
  tabName?: string;
  subscriptionType?: string;
  bearerToken?: string;
  requestContext?: IRequestContext;
  toggleFeatureScopeOne?: boolean;
  nilmTab?: string;
  setHeader?: any;
  getAllMeterData?: meterDetailsFromParent[];
  getCurrentPage?: any;
  MAX_METERS_COUNT?: number;
  utilityType?: string;
  emaasContext?: IEMaaSContext;
  scope?: string;
  ActiveIndex?: number;
  isSite?: boolean;
  dataSourceType?: IAny;
}

export interface IDetailComponentPropsTwoSeparateAPI {
  dataConnector: IConnector<IAny>;
  dataConnectorForGraph: IConnector<IAny>;
  dataSourceType?: IAny;
  avoidanceData?: ICarbonAvoidanceData;
  UtilityBillType?: string;
  headerTitle?: string;
  tabName?: string;
  subscriptionType?: string;
  bearerToken?: string;
  requestContext?: IRequestContext;
  toggleFeatureScopeOne?: boolean;
  nilmTab?: string;
  setHeader?: any;
  getAllMeterData?: meterDetailsFromParent[];
  getCurrentPage?: any;
  MAX_METERS_COUNT?: number;
  utilityType?: string;
  emaasContext?: IEMaaSContext;
  scope?: string;
  ActiveIndex?: number;
}
export interface IDetailComponentPropsTwoTableSeparate {
  dataConnector: IConnector<IAny>;
  dataConnectorTable: IConnector<IAny>;
  avoidanceData?: ICarbonAvoidanceData;
  UtilityBillType?: string;
  headerTitle?: string;
  tabName?: string;
  subscriptionType?: string;
  bearerToken?: string;
  requestContext?: IRequestContext;
  toggleFeatureScopeOne?: boolean;
  nilmTab?: string;
  setHeader?: any;
  getAllMeterData?: meterDetailsFromParent[];
  getCurrentPage?: any;
  MAX_METERS_COUNT?: number;
  utilityType?: string;
  emaasContext?: IEMaaSContext;
  scope?: string;
  ActiveIndex?: number;
}
export interface IDetailComponentPropsTableSeparate {
  dataConnector: IConnector<IAny>;
  dataConnectorTable: IConnector<IAny>;
  avoidanceData?: ICarbonAvoidanceData;
  UtilityBillType?: string;
  headerTitle?: string;
  tabName?: string;
  subscriptionType?: string;
  bearerToken?: string;
  requestContext?: IRequestContext;
  toggleFeatureScopeOne?: boolean;
  nilmTab?: string;
  setHeader?: any;
  getAllMeterData?: meterDetailsFromParent[];
  getCurrentPage?: any;
  MAX_METERS_COUNT?: number;
  utilityType?: string;
  emaasContext?: IEMaaSContext;
  scope?: string;
  ActiveIndex?: number;
  getCurrentPageInfinite?: IAny;
}

// export interface IDetailComponentProps {
//   dataConnector: IConnector<IAny>;
//   avoidanceData?: ICarbonAvoidanceData;
//   UtilityBillType?: string;
//   headerTitle?: string;
//   tabName?: string;
//   subscriptionType?: string;
//   bearerToken?: string;
//   requestContext?: IRequestContext;
//   toggleFeatureScopeOne?: boolean;
//   nilmTab?: string;
//   setHeader?: any;
//   getAllMeterData?: meterDetailsFromParent[];
//   getCurrentPage?: any;
//   MAX_METERS_COUNT?: number;
//   utilityType?: string;
//   emaasContext?: IEMaaSContext;
//   scope?: string;
//   ActiveIndex?: number;
// }

export interface IDetailComponentProps {
  dataConnector: IConnector<IAny>;
  avoidanceData?: ICarbonAvoidanceData;
  UtilityBillType?: string;
  headerTitle?: string;
  tabName?: string;
  subscriptionType?: string;
  bearerToken?: string;
  requestContext?: IRequestContext;
  toggleFeatureScopeOne?: boolean;
  nilmTab?: string;
  setHeader?: any;
  getAllMeterData?: meterDetailsFromParent[];
  getCurrentPage?: any;
  MAX_METERS_COUNT?: number;
  utilityType?: string;
  emaasContext?: IEMaaSContext;
  scope?: string;
  ActiveIndex?: number;
  tableData?: Array<IAny> | undefined;
  toggleSeparateApi?: boolean;
  isMonthly?: boolean;
  isSite?: boolean;
  selectedAccountNumber?: any;
  tableDataAsync?: IAny;
  tableLoader?: boolean;
  dataConnectorForGraph?: IAny;
  dataConnectorTable?: IAny;
  dataConnectorForTable?: IAny;
  dataSourceType?: string;
}

export interface IDetailComponentPropsSeparate {
  dataConnector: IConnector<IAny>;
  dataConnectorForGraph: IConnector<IAny>;
  dataConnectorForTable?: IConnector<IAny>;
  avoidanceData?: ICarbonAvoidanceData;
  UtilityBillType?: string;
  headerTitle?: string;
  tabName?: string;
  subscriptionType?: string;
  bearerToken?: string;
  requestContext?: IRequestContext;
  toggleFeatureScopeOne?: boolean;
  nilmTab?: string;
  setHeader?: any;
  getAllMeterData?: meterDetailsFromParent[];
  getCurrentPage?: any;
  MAX_METERS_COUNT?: number;
  utilityType?: string;
  emaasContext?: IEMaaSContext;
  scope?: string;
  ActiveIndex?: number;
  tableData?: Array<IAny> | undefined;
  toggleSeparateApi?: boolean;
  isSite?: boolean;
  dataSourceType?: string;
}

export interface IDetailComponentPropsTwoSeparate {
  dataConnector: IConnector<IAny>;
  dataConnectorForGraph: IConnector<IAny>;
  dataConnectorForTable: IConnector<IAny>;
  avoidanceData?: ICarbonAvoidanceData;
  UtilityBillType?: string;
  headerTitle?: string;
  tabName?: string;
  subscriptionType?: string;
  bearerToken?: string;
  requestContext?: IRequestContext;
  toggleFeatureScopeOne?: boolean;
  nilmTab?: string;
  setHeader?: any;
  getAllMeterData?: meterDetailsFromParent[];
  getCurrentPage?: any;
  MAX_METERS_COUNT?: number;
  utilityType?: string;
  emaasContext?: IEMaaSContext;
  scope?: string;
  ActiveIndex?: number;
  tableData?: Array<IAny> | undefined;
  toggleSeparateApi?: boolean;
  isSite?: boolean;
  dataSourceType?: string;
}

export interface IDetailComponentPropsApiSeparate {
  dataConnector?: IConnector<IAny>;
  dataConnectorForTable: IConnector<IAny>;
  avoidanceData?: ICarbonAvoidanceData;
  UtilityBillType?: string;
  headerTitle?: string;
  tabName?: string;
  subscriptionType?: string;
  bearerToken?: string;
  requestContext?: IRequestContext;
  toggleFeatureScopeOne?: boolean;
  nilmTab?: string;
  setHeader?: any;
  getAllMeterData?: meterDetailsFromParent[];
  getCurrentPage?: any;
  MAX_METERS_COUNT?: number;
  utilityType?: string;
  emaasContext?: IEMaaSContext;
  scope?: string;
  ActiveIndex?: number;
  tableData?: Array<IAny> | undefined;
  toggleSeparateApi?: boolean;
}

export interface IDetailComponentPropsScopeSeparateAPI {
  dataConnector?: IConnector<IAny>;
  dataConnectorPerformanceAggregation?: IConnector<IAny>;
  avoidanceData?: ICarbonAvoidanceData;
  UtilityBillType?: string;
  headerTitle?: string;
  tabName?: string;
  subscriptionType?: string;
  bearerToken?: string;
  requestContext?: IRequestContext;
  toggleFeatureScopeOne?: boolean;
  nilmTab?: string;
  setHeader?: any;
  getAllMeterData?: meterDetailsFromParent[];
  getCurrentPage?: any;
  MAX_METERS_COUNT?: number;
  utilityType?: string;
  emaasContext?: IEMaaSContext;
  scope?: string;
  ActiveIndex?: number;
  tableData?: any;
  loading?: any;
  error?: any;
  statusCode?: any;
  onRefresh?: () => Promise<IAny>;
}

export interface IEmaasEnergyUsageComponentDataZone {
  areaWiseAggregations: Array<ZoneWiseAggregations>;
  oatSeries?: Array<IBasicMonthWise>;
  ActiveIndex?: number;
  aggregationsStartDate: string;
  aggregationsEndDate: string;
  energyMeasurementUnit: string;
  rootNodeId: string;
  nodeId: string;
  sourceType: string;
  summary: ISummaryData;
  totalSiteCount: number;
  breakdownByMeter: Array<IBreakdownByMeterProps>;
  breakdownByUtility: Array<ICost>;
  performanceAggregation: Array<IPerformanceAggregationProps>;
  performanceAggregationApplied: string;
  subscriptionType: string;
  addOn?: IAny[];
  monthWiseAggregations: Array<IBasicMonthWise>;
  breakdownBySite?: ISiteEnergyUsageData[];
  euiEnergyMeasuringUnit?: string;
  euiSummary?: IEuiSummary;
  nilmAggregation?: NilmAggregation;
  intervalType: string;
}

export interface ZoneWiseAggregations {
  id: string;
  totalItems?: number;
  meterWiseAggregations:
    | Array<IBreakdownByMeterProps>
    | Array<{ id: string; sourceType?: string }>;
  name: string;
  totalBaselineConsumption: number;
  totalConsumption: number;
  totalEnergyDeviation: number;
  totalEnergyDeviationPercentage: number;
  totalNativeBaselineConsumption: number;
  totalNativeConsumption: number;
  totalNativeEnergyDeviation: number;
  totalNativeEnergyDeviationPercentage: number;
  totalAbsoluteConsumption: null | number;
  totalAbsoluteBaselineConsumption: number | null;
  sortedMeterIds: Array<{ id: string }>;
  dataSourceType?: EnergyUsageDataSourceType | string | null;
}
export interface IPerformanceDetailComponentProps {
  dataConnector: IConnector<IAny>;
  commonProps: IObject;
  UtilityBillType?: string /* once utilityType fixed from backend side then will remove this*/;
  onViewDetailsClick?: () => void;
  isOverview?: boolean;
}
export interface IObject {
  [key: string]: string;
}
export type IDateRange = {
  startDateTime: string;
  endDateTime: string;
  interval: string;
};

export type IDateOption = {
  label?: string;
  value?: number;
  get: () => IDateRange;
};

export interface IUtilityCostData {
  organizationId?: string;
  aggregationsStartDate?: string;
  aggregationsEndDate?: string;
  utilityType?: string;
  utilityMeasurementUnit: string;
  totalAggregations: IUtility;
  breakdownByUtility: Array<IUtilityProps>;
  monthwiseAggregations: Array<ICost>;
  utilityCostCurrency?: string;
  totalSiteCount?: number;
  breakdownBySite: Array<{
    aggregations: {
      totalActualCost: number;
      previousPeriodCost: number;
      totalCostSavingsPercentage: number;
      totalConsumptionSavings: number;
      totalConsumptionSavingsPercentage: number;
      totalCostSavings: number;
      totalActualConsumption: number;
      previousPeriodConsumption: number;
    };
    isCompleted: boolean;
  }>;
}
export interface IUtility {
  totalActualCost: number;
  previousPeriodCost: number;
  totalCostSavingsPercentage: number;
  totalCostSavings: number;
}

export interface ICost {
  sourceType: string;
  measurementUnit: string;
  previousPeriodCost: number;
  totalActualCost: number;
  isCompleted: boolean;
}

export interface IUtilityCost {
  meterNumber: string;
  meterId: string;
  meter: string;
  meterType: string;
  aggregations: IUtilityAggregations;
  meterName: string;
}

export interface IUtilityAggregations {
  totalActualConsumption: number;
  previousPeriodConsumption: number;
  percentageConsumptionSaving: number;
  totalActualCost: number;
  previousPeriodCost: number;
  percentageCostSavings: number;
  totalConsumptionSavings: number;
  totalCostSavings: number;
  totalCostSavingsPercentage: number;
  totalConsumptionSavingsPercentage: number;
}

export interface ICarbonData {
  aggregationsStartDate?: string;
  aggregationsEndDate?: string;
  breakdownBySite?: null;
  emissionType?: string;
  emissionMeasurementUnit: string;
  rootNodeName?: string;
  rootNodeId: string;
  nodeId: string;
  totalSiteCount: number;
  totalAggregations: ITotalAggregation;
  monthWiseAggregations: Array<IMonthWise>;
  emissionsByUtility: Array<IEmissionsByUtility>;
  breakdownByMeter?: Array<IMeter>;
  emissionsByScope?: any;
}

export interface IEnergyUsagesSummary {
  totalBaselineConsumption: number;
  totalConsumption: number;
  totalEnergyDeviation: number;
  totalEnergyDeviationPercentage: number;
}

export interface IMonthWise {
  totalActualEmission: number;
  totalPreviousPeriodEmission: number;
  totalPreviousPeriodAvoidance: number;
  totalActualAvoidance: number;
  monthStartDate: string;
  monthEndDate: string;
  isCompleted: boolean;
  emissionProcessedDays: number;
  emissionsBySubUtility?: Array<ISubUtilityEmission>;
  sitesWithData?: number;
}

export interface IMonthwiseStackedChartData {
  totalActualEmission: number;
  totalPreviousPeriodEmission: number;
  totalPreviousPeriodAvoidance: number;
  totalActualAvoidance: number;
  monthStartDate: string;
  monthEndDate: string;
  isCompleted: boolean;
  emissionProcessedDays: number;
  emissionsByFuelType: EmissionsByFuelType[];
  sitesWithData?: number;
}

export interface IMonthwiseStackedChartDataEnergy {
  totalConsumption: number;
  totalBaselineConsumption: number;
  monthStartDate: string;
  monthEndDate: string;
  isCompleted: boolean;
  consumptionProcessedDays: number;
  disaggregation: DisaggregationType[];
}
export interface EmissionsByFuelType {
  subScopeType: string;
  isLive: boolean;
  fuelTypeId: string;
  fuelTypeName: string;
  totalActualEmission: number;
  totalPreviousPeriodEmission: number;
  totalActualAvoidance: number;
  totalPreviousPeriodAvoidance: number;
  totalDeviation: number;
  totalDeviationPercentage: number;
}

export interface DisaggregationType {
  isLive: boolean;
  meterId: string;
  meterName: string;
  totalConsumption: number;
  totalBaselineConsumption: number;
}

export interface Disaggregation {
  id: string;
  name: string;
  totalConsumption: number;
  baselineConsumption: number;
  isCompleted: boolean;
  consumptionProcessedDays: number;
}

export interface ISubUtilityEmission {
  isLive: boolean;
  subUtilityId: string;
  subUtilityType: string;
  totalActualEmission: number | null;
  totalPreviousPeriodEmission: number | null;
  totalActualAvoidance: number | null;
  totalPreviousPeriodAvoidance: number | null;
  totalDeviation: number | null;
  totalDeviationPercentage: number | null;
}

export interface IBasicMonthWise {
  consumptionProcessedDays: number;
  isCompleted: boolean;
  monthEndDate: string;
  monthStartDate: string;
  totalBaselineConsumption: number;
  totalConsumption: number;
  disaggregation?: DisaggregationType[];
  sitesWithData?: number;
}
export interface ITotalAggregation {
  totalActualEmission: number;
  totalPreviousPeriodEmission: number;
  totalDeviation: number;
  totalDeviationPercentage: number;
}
export interface ITotalAvoidanceAggregation {
  totalActualAvoidance: number;
  totalPreviousPeriodAvoidance: number;
  totalDeviation: number;
  totalDeviationPercentage: number;
}
export interface IEmissionsByUtility {
  utilityType?: string;
  totalActualEmission: number;
  totalPreviousPeriodEmission: number;
  totalActualAvoidance: number;
  totalPreviousPeriodAvoidance: number;
  totalDeviation: number;
  totalDeviationPercentage: number;
  totalConsumption: number | null;
  totalBaselineConsumption: number | null;
  totalEnergyDeviation: number | null;
  totalEnergyDeviationPercentage: number | null;
  sourceType: string;
  measurementUnit: string;
  totalAbsoluteConsumption: number | null;
  totalAbsoluteBaselineConsumption: number | null;
  unit?: string;
}
export interface ISite {
  siteId: string;
  siteName?: string;
  totalActualEmission: number;
  totalPreviousPeriodEmission: number;
  totalDeviation: number;
  totalDeviationPercentage: number;
  isCompleted: boolean;
}

export interface IFuelType {
  fuelTypeName?: string;
  isLive?: boolean;
  combustionType?: string;
  fuelTypeId?: string;
  totalActualEmission: number;
  totalPreviousPeriodEmission: number;
  totalDeviation: number;
  totalDeviationPercentage: number;
  emissionsByFuelType?: Array<IFuelType> | null;
  emissionsBySubScope?: Array<IFuelType> | undefined;
  scope?: string;
}

export interface IMeter {
  meterId: string;
  meterName?: string;
  utilityType: string;
  totalActualEmission: number;
  totalPreviousPeriodEmission: number;
  totalActualAvoidance: number;
  totalPreviousPeriodAvoidance: number;
  totalDeviation: number;
  totalDeviationPercentage: number;
}
export interface IEnergyMeter {
  id: string;
  name?: string;
  sourceType: string;
  totalBaselineConsumption: number | null;
  totalConsumption: number | null;
  totalEnergyDeviation: number | null;
  totalEnergyDeviationPercentage: number | null;
  totalNativeBaselineConsumption: number;
  totalNativeConsumption: number;
  totalNativeEnergyDeviation: number;
  totalNativeEnergyDeviationPercentage: number;
  totalAbsoluteConsumption: number | null;
  totalAbsoluteBaselineConsumption: number | null;
}

export interface IAccountsData {
  organizationId: string;
  facilityId: string;
  accountNumber: string;
  serviceProdiverId: string;
  serviceTypeId: string;
  status: string;
  utilityProviderName: string;
  serviceTypeName: string;
}

export interface IAllModelProps {
  constantValue: number;
  constantName: string;
}

export type IArraySeries = Array<[number | string, number | null]>;
export interface IServiceProvider {
  utilityProviderId: string;
  utilityProviderName: string;
}

export interface IUtiltityAccountResponse {
  data?: Array<{ title: string; detail: string }>;
  error?: Array<{ title: string; detail: string }>;
}

export interface ISummaryData {
  totalConsumption: number | null;
  totalBaselineConsumption: number | null;
  totalEnergyDeviation: number | null;
  totalEnergyDeviationPercentage: number | null;
  absoluteTotalBaselineConsumption: number | null;
  absoluteTotalConsumption: number | null;
  // #TODO Water Meter remove optional during api integration
  avgMonthlyConsumption?: number | null;
  avgDailyConsumption?: number | null;
  monthlyConsumptionPersqft?: number | null;
}

export interface IBreakdownSitesProps {
  name: string;
  id?: string;
  totalConsumption: number;
  totalBaselineConsumption: number;
  totalEnergyDeviation: number;
  totalEnergyDeviationPercentage: number;
}

export interface ISingleSiteEnergyUsageData {
  rootNodeId: string;
  rootNodeName: string;
  aggregationsStartDate?: string;
  aggregationsEndDate?: string;
  energyMeasurementUnit: string;
  nodeName: string;
  nodeId: string;
  summary: ISummaryData;
}

export interface IUtilityBillData {
  organizationId?: string;
  aggregationsStartDate?: string;
  aggregationsEndDate?: string;
  utilityType?: string;
  utilityMeasurementUnit: string;
  totalAggregations: IUtilityBill;
  breakdownByUtility: Array<IUtilityProps>;
  monthwiseAggregations: Array<ICost>;
  utilityCostCurrency: string;
  breakdownBySite: Array<{
    isCompleted: boolean;
    aggregations: {
      previousPeriodCost: number | null;
      totalActualCost: number | null;
    };
  }>;
  totalSiteCount?: number;
}

export interface IUtilityBill {
  totalActualCost: number;
  previousPeriodCost: number;
  totalCostSavingsPercentage: number;
  totalCostSavings: number;
  totalActualConsumption: number;
  previousPeriodConsumption: number;
}

export interface IConvertDataForUtilityTrendChart {
  consumptionProcessedDays: number;
  isCompleted: boolean;
  monthEndDate: string;
  monthStartDate: string;
  previousPeriodConsumption: number;
  previousPeriodCost: number;
  totalActualConsumption: number;
  totalActualCost: number;
  sitesWithData?: number;
}
export interface IUtilityBillElectData {
  organizationId?: string;
  aggregationsStartDate?: string;
  aggregationsEndDate?: string;
  utilityType: string;
  utilityMeasurementUnit: string;
  totalAggregations: IUtilityBillElect;
  utilityMeters: Array<IUtilityCost>;
  monthwiseAggregations: Array<IConvertDataForUtilityTrendChart>;
  utilityCostCurrency: string;
  breakdownBySite: Array<IUtilityPercentProps>;
}

export interface IUtilityPercentProps {
  aggregations: {
    totalActualCost: number;
    previousPeriodCost: number;
    totalCostSavingsPercentage: number;
    totalConsumptionSavings: number;
    totalConsumptionSavingsPercentage: number;
    totalCostSavings: number;
    totalActualConsumption: number;
    previousPeriodConsumption: number;
  };
  isCompleted: boolean;
}
export interface IUtilityBillElect {
  totalActualCost: number;
  previousPeriodCost: number;
  totalCostSavingsPercentage: number;
  totalConsumptionSavings: number;
  totalConsumptionSavingsPercentage: number;
  totalCostSavings: number;
  totalActualConsumption: number;
  previousPeriodConsumption: number;
  isCompleted: boolean;
}
export interface EnergyDisaggregation {
  consumptionProcessedDays: number;
  isCompleted: boolean;
  endDateTime: string;
  startDateTime: string;
  baselineConsumption: number;
  totalConsumption: number;
  disaggregation: Disaggregation[];
}
export interface EnergyUsageAggregation {
  consumptionProcessedDays: number;
  isCompleted: boolean;
  usageDateTime: string;
  totalConsumption: number;
  totalBaselineConsumption: number;
  disaggregation: Disaggregation[];
}

interface IDisagreegation {
  id: string;
  name: string;
  totalConsumption: number;
  baselineConsumption: number;
  isCompleted: boolean;
  consumptionProcessedDays: number;
}
export interface EquipmentTypeAggregation {
  sourceType: string;
  totalConsumption: number;
  totalBaselineConsumption: number;
  totalEnergyDeviation: number;
  totalEnergyDeviationPercentage: number;
  measurementUnit: string;
  isCompleted: boolean;
  consumptionProcessedDays: number;
}

interface INILMDisagreegation {
  disaggregation: Array<IDisagreegation>;
  totalConsumption: number;
  baselineConsumption: number;
  startDateTime: string;
  endDateTime: string;
  isCompleted: true;
  consumptionProcessedDays: 7;
}

interface INILMEnergyUsage {
  disaggregation: Array<IDisagreegation>;
  totalConsumption: number;
  totalBaselineConsumption: number;
  usageDateTime: string;
  isCompleted: boolean;
  consumptionProcessedDays: number;
}

export interface MeterwiseDisaggregation {
  id: string;
  name: string;
  totalConsumption: number;
  baselineConsumption: number;
}

export interface MeterwiseAggregation {
  id: string;
  name: string;
  isMainMeter: boolean;
  sourceType: string;
  totalConsumption: number;
  totalBaselineConsumption: number;
  totalAbsoluteConsumption: null | number;
  totalAbsoluteBaselineConsumption: null | number;
  totalNativeAbsoluteActualConsumption: null | number;
  totalNativeAbsolutePredictedConsumption: null | number;
  totalEnergyDeviation: null | number;
  totalEnergyDeviationPercentage: null | number;
  totalNativeConsumption: null | number;
  totalNativeBaselineConsumption: null | number;
  totalNativeEnergyDeviation: null | number;
  totalNativeEnergyDeviationPercentage: null | number;
  disaggregation: MeterwiseDisaggregation[];
}
export interface NilmAggregation {
  energyDisaggregation: EnergyDisaggregation[];
  energyUsageAggregation: EnergyUsageAggregation[];
  equipmentTypeAggregation: EquipmentTypeAggregation[];
  meterWiseAggregation: MeterwiseAggregation[];
  summary?: ISummaryData;
}
export interface IEmaasEnergyUsageComponentData {
  aggregationsStartDate: string;
  aggregationsEndDate: string;
  energyMeasurementUnit: string;
  rootNodeId: string;
  nodeId: string;
  sourceType: string;
  summary: ISummaryData;
  totalSiteCount: number;
  breakdownByMeter: Array<IBreakdownByMeterProps>;
  breakdownByUtility: Array<ICost>;
  performanceAggregation: Array<IPerformanceAggregationProps>;
  performanceAggregationApplied: string;
  subscriptionType: string;
  addOn?: IAny[];
  monthWiseAggregations: Array<IBasicMonthWise>;
  breakdownBySite?: ISiteEnergyUsageData[];
  euiEnergyMeasuringUnit?: string;
  euiSummary?: IEuiSummary;
  areaWiseAggregations: Array<AreaWiseAggregations>;
  nilmAggregation?: NilmAggregation;
  intervalType: string;
}
export interface IEmaasWaterUsageComponentData {
  aggregationsStartDate: string;
  aggregationsEndDate: string;
  energyMeasurementUnit: string;
  rootNodeId: string;
  nodeId: string;
  sourceType: string;
  summary: ISummaryData;
  totalSiteCount: number;
  breakdownByMeter: Array<IBreakdownByMeterProps>;
  breakdownByUtility: Array<ICost>;
  performanceAggregation: Array<IPerformanceAggregationProps>;
  performanceAggregationApplied: string;
  subscriptionType: string;
  addOn?: IAny[];
  monthWiseAggregations: Array<IBasicMonthWise>;
  breakdownBySite?: ISiteEnergyUsageData[];
  euiEnergyMeasuringUnit?: string;
  euiSummary?: IEuiSummary;
  areaWiseAggregations: Array<AreaWiseAggregations>;
  nilmAggregation?: NilmAggregation;
  intervalType: string;
}

export interface IEmaasEnergyUsageComponentDataV2 {
  aggregationsStartDate: string;
  aggregationsEndDate: string;
  energyMeasurementUnit: string;
  rootNodeId: string;
  nodeId: string;
  sourceType: string;
  summary: ISummaryData;
  totalSiteCount: number;
  breakdownByMeter: Array<IBreakdownByMeterProps>;
  breakdownByUtility: Array<ICost>;
  performanceAggregation: Array<IPerformanceAggregationProps>;
  performanceAggregationApplied: string;
  subscriptionType: string;
  addOn: string[];
  monthWiseAggregations: Array<IBasicMonthWise>;
  breakdownBySite?: ISiteEnergyUsageData[];
  euiEnergyMeasuringUnit?: string;
  euiSummary?: IEuiSummary;
  areaWiseAggregations: Array<AreaWiseAggregations>;
  nilmAggregation: NilmAggregation;
  intervalType: string;
}

export interface IEmaasEnergyUsageComponentDataArea
  extends IEmaasEnergyUsageComponentData {
  areaWiseAggregations: Array<AreaWiseAggregations>;
  oatSeries?: Array<IBasicMonthWise>;
  ActiveIndex?: number;
}

export interface IEmaasEnergyUsageComponentDataAreaV2
  extends IEmaasEnergyUsageComponentDataV2 {
  areaWiseAggregations: Array<AreaWiseAggregations>;
  oatSeries?: Array<IBasicMonthWise>;
}

// export interface AreaWiseAggregations {
//   totalItems: any;
//   id: string;
//   meterWiseAggregations: Array<IBreakdownByMeterProps>;
//   name: string;
//   totalBaselineConsumption: number;
//   totalConsumption: number;
//   totalEnergyDeviation: number;
//   totalEnergyDeviationPercentage: number;
//   totalNativeBaselineConsumption: number;
//   totalNativeConsumption: number;
//   totalNativeEnergyDeviation: number;
//   totalNativeEnergyDeviationPercentage: number;
//   totalAbsoluteConsumption: null | number;
//   totalAbsoluteBaselineConsumption: number | null;
// }

export interface AreaWiseAggregations {
  id: string;
  totalItems?: number;
  meterWiseAggregations: Array<IBreakdownByMeterProps>;
  name: string;
  totalBaselineConsumption: number;
  totalConsumption: number;
  totalEnergyDeviation: number;
  totalEnergyDeviationPercentage: number;
  totalNativeBaselineConsumption: number;
  totalNativeConsumption: number;
  totalNativeEnergyDeviation: number;
  totalNativeEnergyDeviationPercentage: number;
  totalAbsoluteConsumption: null | number;
  totalAbsoluteBaselineConsumption: number | null;
  sortedMeterIds: Array<{ id: string }>;
}

export interface IEuiSummary {
  totalEuiArea: number;
  totalEuiConsumption: number;
  message: string;
}

export interface IEuiV4 {
  data: {
    euiSummary: IEuiSummary;
  };
}

export interface IEnergyOptimizationSummaryData {
  estimatedSavings: number;
  actualSavings: number | null;
  calculatedSavings: number | null;
  eoEnableDaysSavingPercentage: number;
  entirePeriodSavingPercentage: number;
  operationalTimePercentage: number;
  totalEODeviationPercentage: number;
  timeUsedForBaseline?: number;
  opportunityFromEO?: number;
}

export interface IEmaasEnergyOptimizationComponentData {
  aggregationsStartDate: string;
  aggregationsEndDate: string;
  summary: IEnergyOptimizationSummaryData;
  dataItems: IDataPoint[];
  currentState?: IStateValue | null;
  utilityType?: string;
}

export interface IBreakdownByMeterProps {
  name: string;
  id: string;
  sourceType: string;
  totalConsumption: number | null;
  totalBaselineConsumption: number | null;
  totalEnergyDeviation: number | null;
  totalEnergyDeviationPercentage: number | null;
  totalNativeConsumption: number | null;
  totalNativeBaselineConsumption: number | null;
  totalNativeEnergyDeviationPercentage: number | null;
  totalNativeEnergyDeviation: number | null;
  totalAbsoluteConsumption: null | number;
  totalAbsoluteBaselineConsumption: number | null;
  tags?: string[];
}

export interface IBreakdownByUtilityProps {
  sourceType: string;
  totalConsumption: number;
  totalEnergyDeviation: number;
}

export interface IPerformanceAggregationProps {
  consumption: number | null;
  baselineConsumption: number | null;
  consumptionDate: string;
}
export interface IEuiResponse {
  status: string;
  message: string;
  data: IEuiData;
}
export interface IEuiData {
  euiCalculatedMonth: string;
  euiMeasurementUnit: string;
  areaPerSQft: number;
  siteWiseCalculation: IEuiDataDetails[];
}
interface IEuiDataDetails {
  actualEui: number;
  baselineEui: number;
  euiDeviation: number;
  euiDeviationPercentage: number;
}

export interface ISiteCard {
  onRefresh: () => Promise<void>;
}

export interface IEmaasEnergyUsageHOCProps {
  bearerToken?: string;
  requestContext: IRequestContext;
  emaasContext?: IAny;
  dataSourceType?: EnergyUsageDataSourceType | string | null;
  setDataSourceType?: (
    dataSourceType: EnergyUsageDataSourceType | string | null
  ) => void;
  optimusSubscribed?: boolean;
  isEnergyDeatils?: Function;
}
export interface IEmaasWaterUsageHOCProps {
  bearerToken?: string;
  requestContext: IRequestContext;
  emaasContext?: IAny;
  dataSourceType?: string;
}

export interface ICarbonScopeDetailWithLoaderContent extends ISiteCard {
  data: ICarbonScopeOneData | ICarbonScopeOneStackedData;
  onRefresh: () => Promise<void>;
  forGraph?: boolean;
  forSummary?: boolean;
  // forTable?: boolean;
  carbonAllSiteMonthData?: boolean;
  requestContext?: IRequestContext;
  dataSourceType?: string;
  checkAllSitesData?: boolean;
  isSite?: boolean;
}

export interface ICarbonScopeDetailWithLoaderContentFilter extends ISiteCard {
  data: IAny;
  closeModal?: IAny;
  saveData?: IAny;
  setData?: IAny;
  resetModal?: IAny;
}

export interface ICarbonScopeOneData {
  // summary: ICarbonScopeOneData;
  // onRefresh: () => Promise<void>;
  emissionMeasurementUnit: string;
  emissionType: string;
  rootNodeId: string;
  rootNodeName?: null;
  nodeId: string;
  aggregationsStartDate: string;
  aggregationsEndDate: string;
  totalAggregations: ITotalAggregation;
  monthWiseAggregations: Array<IMonthWise>;
  monthWiseEmissionByFuelType?: IAny;
  emissionsByUtility: Array<IEmissionsByUtility>;
  totalSiteCount: number;
  breakdownByMeter: Array<IMeter>;
  breakdownBySite?: Array<ISite>;
  subscriptionType: string;
  emissionsByScope?: Array<IFuelType>;
  carbonAllSiteMonthData?: boolean;
}
export interface ICarbonAvoidanceData {
  emissionMeasurementUnit: string;
  emissionType: string;
  rootNodeId: string;
  rootNodeName?: null;
  nodeId: string;
  aggregationsStartDate: string;
  aggregationsEndDate: string;
  totalAggregations: ITotalAvoidanceAggregation;
  monthWiseAggregations: Array<IMonthWise>;
  totalSiteCount: number;
  breakdownBySite?: Array<ISite>;
  energySource: string;
  utilityType: string;
}

export interface ICarbonScopeOneStackedData {
  emissionMeasurementUnit: string;
  emissionType: string;
  rootNodeId: string;
  rootNodeName?: null;
  nodeId: string;
  aggregationsStartDate: string;
  aggregationsEndDate: string;
  totalAggregations: ITotalAggregation;
  monthWiseEmissionByFuelType: Array<IMonthwiseStackedChartData>;
  emissionsByUtility: Array<IEmissionsByUtility>;
  totalSiteCount: number;
  breakdownByMeter: Array<IMeter>;
  breakdownBySite?: Array<ISite>;
  subscriptionType: string;
}

export interface ICarbonScopeOneSavingsByMeterDetailComponentProps {
  data: ICarbonScopeOneData;
  UtilityBillType: string;
  scope?: string;
  forTable?: boolean;
}
export interface ICarbonAvoidanceSummaryComponentProps {
  data: ICarbonAvoidanceData;
}
export interface IEnergyData {
  aggregationsStartDate?: string;
  aggregationsEndDate?: string;
  breakdownBySite?: null;
  emissionType?: string;
  energyMeasurementUnit: string;
  rootNodeName?: string;
  rootNodeId: string;
  nodeId: string;
  totalSiteCount: number;
  totalAggregations: ITotalAggregation;
  monthWiseAggregations: Array<IMonthWise>;
  breakdownByUtility: Array<IEmissionsByUtility>;
  breakdownByMeter?: Array<IEnergyMeter>;
  summary: Isummary;
  subscriptionType: string;
  nilmAggregation?: NilmAggregation;
}
export interface Isummary {
  totalConsumption: number;
  totalBaselineConsumption: number;
}
export interface IEnergyUsageDetails {
  consumption: number;
  baselineConsumption: number;
}
export interface ISiteSavingsData {
  site?: string;
  siteId?: string;
  actualConsumption: number | null;
  baselineConsumption: number | null;
  change: number | null;
  percentageConsumptionSaving: number | null;
  unit?: string;
  actualUnit?: string;
  baselineUnit?: string;
  changeUnit?: string;
  progressBarActualConsumption: number | null;
  progressBarBaselineConsumption: number | null;
}

export interface IFuelTypeSavingsData {
  combustionType?: string;
  actualConsumption: number | null;
  baselineConsumption: number | null;
  change: number | null;
  percentageConsumptionSaving: number | null;
  emissionsByFuelType?: {
    values: Array<IFuelTypeSavingsData>;
    displayUnit: string;
  } | null;
  emissionsBySubScope?: {
    values: Array<IFuelTypeSavingsData>;
    displayUnit: string;
  } | null;
  isLive?: boolean;
  fuelTypeId?: string;
  fuelTypeName?: string;
  scope?: string;
  progessBarRelativeWidth?: number | null;
  changeUnit?: string;
  actualUnit?: string;
  baselineUnit?: string;
  deviationUnit?: string;
}

export interface IMeterSavingsData {
  meter?: string;
  actualConsumption: number | null;
  baselineConsumption: number | null;
  change: number | null;
  percentageConsumptionSaving: number | null;
  utilityType: string;
  actualUnit?: string;
  baselineUnit?: string;
  changeUnit?: string;
  deviationUnit?: string;
}

export enum ECarbonCartAt {
  portfolioLabel,
  siteLabel
}
export interface IAggregationEnergyData {
  actual: number | null;
  absoluteActual: number | null;
  previousPeriod: number | null;
  absolutePrevPeriod: number | null;
  savings: number | null;
  savingsPercentage: number | null;
}

export interface IAggregationSummaryData {
  actualCost: number | null;
  baselineCost: number | null;
  costSavings: number | null;
  costSavingsPercentage: number | null;
  actualAvoidanceCost: number | null;
  baselineAvoidanceCost: number | null;
}

export enum ECartAt {
  portfolioLabel,
  siteLabel
}

export enum EUtilityConfig {
  allUtilitySiteLabel = 'all-utility',
  allUtilityPortfolioLabel = 'all-utility-portfolio',
  electricityUtilitySiteLabel = 'utility-electricity',
  electricityUtilityPortfolioLabel = 'utility-electricity-portfolio',
  gasUtilitySiteLabel = 'utility-gas',
  gasUtilityPortfolioLabel = 'utility-gas-portfolio',
  waterUtilitySiteLabel = 'utility-water',
  waterUtilityPortfolioLabel = 'utility-water-portfolio',
  sewerageUtilitySiteLabel = 'utility-sewerage',
  seweragePortfolioLabel = 'utility-sewerage-portfolio',
  utilityBill = 'utility-bill'
}

export interface IPortfolioUtilityData {
  emissionMeasurementUnit: string;
  emissionType: string;
  rootNodeId: string;
  rootNodeName?: null;
  nodeId: string;
  aggregationsStartDate: string;
  aggregationsEndDate: string;
  totalAggregations: ITotalAggregation;
  monthWiseAggregations: IMonthWise[];
  emissionsByUtility: IEmissionsByUtility[];
  totalSiteCount: number;
  breakdownBySite?: ISite[];
}
export interface IUtilityCostSavingsData {
  siteName?: string;
  siteId?: string;
  totalActualCost: number | null;
  previousPeriodCost: number | null;
  costSavings: number | null;
  savingsPercentage: number | null;
  progessBarRelativeWidth?: number;
}

export interface IPortfolioUtilityCost {
  siteId: string;
  siteName: string;
  utilityType: string;
  aggregations: IUtilityAggregations;
  isCompleted: boolean;
}
export interface IUtilityCostElectData {
  organizationId?: string;
  aggregationsStartDate?: string;
  aggregationsEndDate?: string;
  utilityType: string;
  utilityMeasurementUnit: string;
  totalAggregations: IUtilityBillElect;
  breakdownBySite: IPortfolioUtilityCost[];
  monthwiseAggregations: IConvertDataForUtilityTrendChart[];
  utilityCostCurrency: string;
}

export type IAny = any;

export interface IEnergyBreakdownMeter {
  meter: string;
  actualConsumption: number | null;
  baselineConsumption: number | null;
  totalAbsoluteConsumption: number | null;
  totalAbsoluteBaselineConsumption: number | null;
  change: number | null;
  percentageConsumptionSaving: number | null;
  utilityType: string;
  rawActualConsumption: number | null;
  rawBaselineConsumption: number | null;
  rawTotalAbsoluteConsumption: number | null;
  rawTotalAbsoluteBaselineConsumption: number | null;
  rawChange: number | null;
  deviationScaledData?: scaledData;
  actualUnit?: string;
  baselineUnit?: string;
  changeUnit?: string;
}

export interface IDisplayTabs {
  displayTabs: ITabDetails[];
  requestContext: IRequestContext;
  ActiveIndex: number | undefined;
}
export interface ITabDetails {
  className: string;
  title: string;
  component: (props: IEnergyManagementProps) => JSX.Element;
}

export interface IMonthWiseBaseObject {
  monthStartDate: string;
  monthEndDate: string;
}

export interface IUsageRateMonthWise extends IMonthWiseBaseObject {
  usage: number;
  costRate: number;
  slabRate?: number;
}

export interface IUtilityBillBreakdownAPIResponse {
  rootNodeId: string;
  nodeId: string;
  aggregationsStartDate: string;
  aggregationsEndDate: string;
  utilityType: string;
  utilityCostCurrency: string;
  summaryTableData: ISummaryTableData;
  utilityAggregations: IBillBreakdownChartAggregations;
}

export interface ISummaryTableData {
  dynamicColumns: IRawTableColumn[];
  data: ISummaryTableDataObject[];
}

export interface IBillBreakdownChartAggregations {
  consumptionOverview: {
    usageUnit: string;
    rateUnit: string;
    name: string;
    actualName: string;
    monthWiseData: IConsumptionOverviewMonthWiseData[];
    nativeRateUnit?: string;
  };
  demandOverview: {
    usageUnit: string;
    rateUnit: string;
    name: string;
    actualName: string;
    monthWiseData: IDemandOverviewMonthWiseData[];
    nativeRateUnit?: string;
  };
  costOverview: { monthWiseData: ICostOverviewMonthWiseData[] };
}

export interface IConsumptionOverviewMonthWiseData
  extends IMonthWiseBaseObject {
  totalUsage: number;
  totalRate: number;
  subcategories: {
    name: string;
    actualName: string;
    usage: number;
    rate: number;
    cost: number;
  }[];
}

export interface IDemandOverviewMonthWiseData extends IMonthWiseBaseObject {
  usage: number;
  rate: number;
}

export interface ICostOverviewMonthWiseData extends IMonthWiseBaseObject {
  totalCost: number;
  subcategories: {
    name: string;
    actualName: string;
    cost: number;
    percentage: number;
  }[];
}

export interface ISummaryTableDataObject {
  accountNumber: string;
  billingCycle: string;
  period: string;
  filePath: string;
  totalcost: number | string;
  consumption: number;
  consumptioncost: number;
  demand: number;
  demandCost: number;
  fixed: number;
  penalties: number;
  taxes: number;
  isSelected?: boolean;
  logicalAccoutId?: string;
  accountId?: string;
  isBillUploaded?: boolean;
  dynamicColumnData: { [key: string]: string }[];
  meterDetails: ISummaryTableDataObject[];
  meterNumber?: string | number;
  meterName?: string;
  isMeter?: boolean;
  demandcharges?: any;
  billingdemand?: any;
  others?: any;
  servicecharges: any;
  recordeddemand: any;
  utilityCostCurrency?: string;
}

export interface IDataTableColumn {
  field: string;
  header?: IAny;
  sortable?: boolean;
  initialWidth?: string;
  width?: string;
  className?: string;
  align?: string;
}
export interface IElementForDisaggMeters {
  name: string;
  id: string;
  tags: string[];
  suppliesSpatialElement?: string[];
  spatialElementInfo?: {
    id: string;
    name: string;
  };
  types?: string[];
  customAttributes?: { key: string; value: IAny }[];
  suppliesElement?: string[];
  [key: string]: IAny;
}

export interface TrainingData {
  id: string;
  siteId: string;
  trainingStartDate: string;
  trainingEndDate: string;
  applyBaselineFrom: string;
  exclusionStartDate: string;
  exclusionEndDate: string;
  trainingStatus: string;
  completedOn: string;
}
export interface IChunkedUploadProgressState {
  fileName: string;
  fileSize: number;
  requestId: string | null;
  progress: number;
  chunkNumber: number;
  chunkCount: number;

  status: 'Uploading' | 'Uploaded' | 'Error' | null;
  statusMessage?: string;

  removed?: boolean;
  hardRemoved?: boolean;
}

export interface IUtilityAccountProps {
  dataConnector: IConnector<IAny>;
  accountNumberUpdateCallBack: any;
}

export interface IUtilityAccountPerformanceProps {
  dataConnector: IConnector<IAny>;
  accountNumberUpdateCallBack: any;
  tableLoader?: boolean;
  graphLoader?: boolean;
}

export interface IUtilityAccountPerformanceData {
  accountNumberUpdateCallBack: any;
  tableLoader?: boolean;
  graphLoader?: boolean;
  accountData: IAny;
  selectedAccountNumber: IAny;
}

export interface IAccount {
  accountNumber: string;
  isSelected: boolean;
}
